import { render, staticRenderFns } from "./HomeNotice.vue?vue&type=template&id=0dfde829&scoped=true"
import script from "./HomeNotice.vue?vue&type=script&lang=js"
export * from "./HomeNotice.vue?vue&type=script&lang=js"
import style0 from "./HomeNotice.vue?vue&type=style&index=0&id=0dfde829&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfde829",
  null
  
)

export default component.exports